import { login } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'

// 后台管理仅允许各类管理员账号登录（正向白名单，2026-09-21 用户拍板：
// 「学校校长」「年级主任」不算管理员不放行；教师账号走备课平台）
const CONSOLE_ADMIN_ROLES = ['系统操作管理员', '管理员', '合作伙伴管理员', '工厂管理员', '教育厅管理员']

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo

    return new Promise((resolve, reject) => {
      login({ account: username.trim(), password: password }).then(response => {
        if (response.code !== 200) {
          reject(response)
          return
        }
        const { result } = response
        // 白名单校验必须在 setToken 之前：action 内先写 cookie 的话，
        // 登录页拦截不住已落地的 token，刷新页面即可绕过
        const userRole = result.role || ''
        if (!CONSOLE_ADMIN_ROLES.includes(userRole)) {
          reject({ code: 403, message: '后台管理仅允许管理员账号登录，当前账号类型为「' + (userRole || '未知') + '」，如需登录，请联系贵组织的管理员处理' })
          return
        }
        commit('SET_TOKEN', result.access_token)
        setToken(result.access_token)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
